/* gcx-pdpcheck: "check your order" before a standard product page adds to the cart or goes to checkout
   (owner, 4 Oct 2026: "after Add to Cart or the quick checkout button ... show a summary/confirm panel like
   the Leather Set and Personalized iPhone Case pages have"). Markup and labels: snippets/gcx-pdpcheck.liquid.

   What it lists, all read from the page at the moment of the press, so it is what the press would buy:
     the variant (its photo, the product title, every option with the form's own translated names and values),
     the initials and their fee when the personalization drawer has staged them (window.currentPersonalization,
     the same object the drawer adds to the cart), each ticked add-on (gift packaging, priority, screen
     protector: the rows' own titles and prices), and the total.

   The panel never adds anything itself.
     Add to Cart: the press is held (window, capture phase; not while a device or color is missing, where the
     page's own "choose a device first" guard still answers), the panel opens, and its Add to Cart presses the form's own button again with
     the hold lifted. Every existing step then runs exactly as before: the drawer attaches the initials and adds
     the fee line, the add-ons, the cart drawer.
     Quick checkout (PayPal, more payment options): those buttons live in Shopify's accelerated-checkout element
     and PayPal's is a cross-origin iframe, which no page script can hold. A transparent button is laid over the
     whole block instead (the block itself is made inert, so the keyboard reaches the shield, not the iframe).
     Its panel button reads Checkout: it adds through the form, as above, waits until /cart.js shows the line,
     and opens /checkout, where PayPal, Shop Pay and the other wallets are all offered.
   Esc, Edit or a tap outside closes it and gives the focus back. Fixed position: nothing on the page moves. */
(function () {
  if (window.__gcxCheck) return;
  window.__gcxCheck = 1;

  var T = {}, PASS = false, open = null, opener = null, veil = null, panel = null;
  function dec(s) { var d = document.createElement('textarea'); d.innerHTML = s == null ? '' : String(s); return d.value; }
  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  /* analytics (assets/gc-track.js, docs/analytics/events-2026-10-04) */
  function gcT(d) { try { document.dispatchEvent(new CustomEvent('gc:track', { detail: d })); } catch (e) {} }
  var gcSrc = ''; /* which button opened the panel: the form's or a sticky (set by the guard below) */

  /* money: the shop's own format, in the shopper's currency */
  var FMT = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  function money(cents) {
    var c = Math.round(cents);
    var m = FMT.match(/\{\{\s*(\w+)\s*\}\}/), kind = m ? m[1] : 'amount';
    function grp(n, d, t, s) {
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return p[0] + (p[1] && +p[1] ? s + p[1] : ''); /* whole: "$89" (owner, 17 Oct 2026) */
    }
    var v = kind === 'amount_no_decimals' ? grp(c, 0, ',', '.') :
      kind === 'amount_with_comma_separator' ? grp(c, 2, '.', ',') :
      kind === 'amount_no_decimals_with_comma_separator' ? grp(c, 0, '.', ',') :
      kind === 'amount_with_apostrophe_separator' ? grp(c, 2, "'", '.') : grp(c, 2, ',', '.');
    return FMT.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function cents(text) { /* a price printed by Liquid's money filter, back to cents */
    /* A whole price now prints without cents ("$25", money_without_trailing_zeros; owner, 17 Oct 2026), so
       the digits alone no longer say where the cents start: "$25" is 2500 and "$71.20" is 7120. Only the
       first amount is read, so a struck "was" price printed beside it is not added in. */
    var m = String(text || '').match(/\d[\d.,']*/);
    if (!m) return 0;
    var a = m[0].replace(/[.,']+$/, ''), d = a.replace(/[^\d]/g, '');
    if (!d) return 0;
    return !/no_decimals/.test(FMT) && /[.,]\d{2}$/.test(a) ? +d : +d * 100;
  }

  function productJSON() {
    var s = document.querySelector('.Product__Info [data-product-json]') || document.querySelector('[data-product-json]');
    try { return JSON.parse(s.textContent).product; } catch (e) { return null; }
  }

  function gather() {
    var p = productJSON();
    var sel = document.querySelector('.Product__Info select[name="id"]') || document.querySelector('select[name="id"]');
    var vid = sel ? sel.value : '';
    var v = p && p.variants ? p.variants.filter(function (x) { return String(x.id) === String(vid); })[0] : null;
    var qtyEl = document.querySelector('.Product__Info [name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var rows = [];
    /* Each option paired by POSITION (11 Oct 2026): its name is the form's own translated label for that position,
       its value is the chosen variant's options[position] from the inline product JSON. The values used to come
       from splitting the variant's localised TITLE, which is stale or in another order in several languages: croco
       46773183250689 is the iPhone 17 Pro Max but is titled "iPhone 17 Pro / ..." in ar, de, el, he, hi, ja, ko, ta
       and zh, and the thin bracelets are titled colour / size while their options are size / colour. So the panel
       could show the wrong model. The title is only the fallback when the JSON has no such variant. */
    var names = [];
    [].forEach.call(document.querySelectorAll('.Product__Info .ProductForm__Variants [data-base-name]'), function (n, i) {
      var q = parseInt(n.getAttribute('data-option-position'), 10);
      q = q > 0 ? q - 1 : i;
      if (names[q] == null) names[q] = n.getAttribute('data-base-name');
    });
    var optName = function (i) {
      var o = p && p.options ? p.options[i] : null;
      return dec(o && typeof o === 'object' ? o.name : o);
    };
    var line = sel && sel.selectedIndex >= 0 ? txt(sel.options[sel.selectedIndex]) : '';
    var vals = v && v.options && v.options.length ?
      v.options.map(function (x) { return dec(x); }) :
      line.replace(/\s+-\s+[^-]*$/, '').split(' / ');
    if (p && !(p.variants && p.variants.length === 1 && /default/i.test((p.variants[0].title || '')))) {
      vals.forEach(function (val, i) { if (val) rows.push({ k: names[i] || optName(i) || '', v: val }); });
    }
    var total = (v ? v.price : 0) * qty;
    var ini = null, cp = window.currentPersonalization;
    var pd = window.PersonalizeDrawer;
    if (cp && cp.initials && (!pd || !pd.currentProductId || !p || String(pd.currentProductId) === String(p.id))) {
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      var fee = Math.round((cp.price || (window.GC_PRICE ? GC_PRICE(cp.initials) : 0)) * 100 * rate);
      ini = { v: cp.initials, fee: fee * qty };
      total += fee * qty;
    }
    var adds = [];
    var bag = p && window.GC_isBagType && window.GC_isBagType(p.type, p.title); /* snippets/gcx-is-bag.liquid */
    [].forEach.call(document.querySelectorAll('.Product__Info [data-gc-addon-check][aria-checked="true"]'), function (b) {
      var row = b.closest('.gc-sp-addon') || b.parentNode;
      if (bag && row && row.closest('.gc-gift-addon')) return; /* no gift packaging on bags (owner, 4 Oct 2026) */
      var title = txt(row && row.querySelector('.gc-sp-addon__title')) || b.getAttribute('aria-label') || '';
      var price = cents(txt(row && row.querySelector('.gc-sp-addon__price')));
      adds.push({ t: title, p: price });
      total += price;
    });
    var img = v && v.featured_image ? v.featured_image.src : (p && p.featured_image) || '';
    return { title: p ? p.title : txt(document.querySelector('.ProductMeta__Title')), img: img, rows: rows, qty: qty, ini: ini, adds: adds, total: total, price: v ? v.price * qty : 0 };
  }

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function imgUrl(src, w) {
    if (!src) return '';
    if (/^\/\//.test(src)) src = 'https:' + src;
    try { var u = new URL(src, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }

  function build(mode) {
    var d = gather();
    panel = el('div', 'gcx-check');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'gcx-check-h');
    var h = el('p', 'gcx-check__h', T.title || 'Check your order');
    h.id = 'gcx-check-h'; h.tabIndex = -1;
    panel.appendChild(h);
    var head = el('div', 'gcx-check__item');
    if (d.img) {
      var im = el('img', 'gcx-check__img');
      im.src = imgUrl(d.img, 160); im.alt = ''; im.width = 64; im.height = 64; im.decoding = 'async';
      head.appendChild(im);
    }
    var hb = el('div', 'gcx-check__itemtxt');
    hb.appendChild(el('span', 'gcx-check__title', d.title + (d.qty > 1 ? ' × ' + d.qty : '')));
    hb.appendChild(el('span', 'gcx-check__price', money(d.price)));
    head.appendChild(hb);
    panel.appendChild(head);
    var dl = el('dl', 'gcx-check__list');
    function row(k, v, cls, price) {
      var r = el('div', 'gcx-check__row' + (cls ? ' ' + cls : ''));
      r.appendChild(el('dt', 'gcx-check__k', k));
      var dd = el('dd', 'gcx-check__v');
      dd.appendChild(el('span', 'gcx-check__val', v));
      if (price != null) dd.appendChild(el('span', 'gcx-check__p', price));
      r.appendChild(dd);
      dl.appendChild(r);
      return r;
    }
    d.rows.forEach(function (r) { row(r.k, r.v); });
    if (d.ini) {
      var ir = row(T.initials || 'Initials', d.ini.v, 'gcx-check__row--ini', '+' + money(d.ini.fee));
      ir.querySelector('.gcx-check__val').setAttribute('dir', 'ltr');
    }
    d.adds.forEach(function (a) { row(T.addons || 'Add-ons', a.t, 'gcx-check__row--add', '+' + money(a.p)); });
    row(T.total || 'Total', money(d.total), 'gcx-check__row--total');
    panel.appendChild(dl);
    var go = el('button', 'Button Button--primary Button--full gcx-check__go');
    go.type = 'button';
    go.appendChild(el('span', '', mode === 'checkout' ? (T.checkout || 'Checkout') : (T.add || 'Add to Cart')));
    go.insertAdjacentHTML('beforeend', '<svg width="20" height="15" viewBox="0 0 20 15" fill="none" aria-hidden="true" focusable="false"><path d="M6 7.5H15M15 7.5L11 4M15 7.5L11 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    var ed = el('button', 'gcx-check__edit', T.edit || 'Edit');
    ed.type = 'button';
    var acts = el('div', 'gcx-check__acts');
    acts.appendChild(go); acts.appendChild(ed);
    panel.appendChild(acts);
    go.addEventListener('click', function () { gcT({ name: 'order_check', surface: 'pdp', action: 'confirm', path: mode === 'checkout' ? 'checkout' : 'add' }); proceed(mode, go); });
    ed.addEventListener('click', function () { gcT({ name: 'order_check', surface: 'pdp', action: 'edit' }); close(true); });
    return panel;
  }

  function focusables() {
    return panel ? [].filter.call(panel.querySelectorAll('button:not([disabled]),[href],[tabindex]:not([tabindex="-1"])'), function (x) { return x.getClientRects().length; }) : [];
  }
  function onKey(e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); gcT({ name: 'order_check', surface: 'pdp', action: 'dismiss' }); close(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  }

  function show(mode, from) {
    if (open) return;
    open = mode;
    gcT({ name: 'order_check', surface: 'pdp', action: 'open', path: mode === 'checkout' ? 'checkout' : 'add', source: mode === 'checkout' ? 'express' : (gcSrc || 'form') });
    opener = from || document.activeElement;
    if (!veil) {
      veil = el('div', 'gcx-check-veil');
      veil.setAttribute('aria-hidden', 'true');
      veil.addEventListener('click', function () { gcT({ name: 'order_check', surface: 'pdp', action: 'dismiss' }); close(true); });
      document.body.appendChild(veil);
    }
    veil.hidden = false;
    document.body.appendChild(build(mode));
    document.body.classList.add('gcx-check-open');
    void veil.offsetWidth;
    veil.classList.add('is-on');
    panel.classList.add('is-on');
    var h = panel.querySelector('#gcx-check-h');
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    document.addEventListener('keydown', onKey, true);
  }
  function close(back) {
    if (!open) return;
    open = null;
    document.removeEventListener('keydown', onKey, true);
    document.body.classList.remove('gcx-check-open');
    if (panel) { var p = panel; panel = null; p.classList.remove('is-on'); setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, reduced() ? 0 : 220); }
    if (veil) { veil.classList.remove('is-on'); var v = veil; setTimeout(function () { if (!open) v.hidden = true; }, reduced() ? 0 : 260); }
    if (back && opener && opener.isConnected && opener.getClientRects().length) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
    opener = null;
  }

  function atcBtn() { return document.querySelector('.Product__Info .ProductForm__AddToCart'); }
  /* true/false from the page's record of the shopper's choice (window.__gcChoice, sections/main-product.liquid,
     11 Oct 2026); null where the page has none (the set builders), and the button classes decide as before */
  function choiceMissing() {
    var c = window.__gcChoice;
    if (!c || typeof c.missing !== 'function') return null;
    try { return c.missing().length > 0; } catch (e) { return null; }
  }

  function proceed(mode, btn) {
    var atc = atcBtn();
    if (!atc) { close(false); return; }
    if (mode === 'checkout') {
      btn.setAttribute('aria-busy', 'true'); btn.disabled = true;
      var want = (document.querySelector('.Product__Info select[name="id"]') || {}).value;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (before) {
        var had = 0;
        if (before) before.items.forEach(function (i) { if (String(i.variant_id) === String(want)) had += i.quantity; });
        PASS = true; atc.click(); PASS = false;
        var t0 = Date.now();
        (function poll() {
          fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            var n = 0; c.items.forEach(function (i) { if (String(i.variant_id) === String(want)) n += i.quantity; });
            if (n > had) { gcT({ name: 'checkout', surface: 'pdp_check' }); location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; return; }
            if (Date.now() - t0 < 12000) setTimeout(poll, 600); else close(false);
          }).catch(function () { if (Date.now() - t0 < 12000) setTimeout(poll, 900); else close(false); });
        })();
      });
      return;
    }
    close(false);
    PASS = true;
    try { atc.click(); } finally { PASS = false; }
  }

  /* ---- Add to Cart: hold the press. On window, capture phase: the very first listener of all, so the
     held press reaches nothing else (gc-product-upsell.js commits a waiting gift box on any Add to Cart
     click it sees at document level; it must see only the press that really adds). While a device or
     color is missing the press is not held: the page's own guard then asks for it, as before. */
  function guardAtc() {
    if (window.__gcxCheckGuard) return;
    window.__gcxCheckGuard = 1;
    window.addEventListener('click', function (e) {
      if (PASS || open) return;
      var atc = atcBtn();
      if (!atc || !e.target || !e.target.closest) return;
      /* the form's button, or one of the two sticky bars that press it (the phone button carries
         data-action="add-to-cart", which gc-product-upsell.js also listens for) */
      var hit = e.target.closest('.ProductForm__AddToCart') === atc ? atc :
        e.target.closest('.cust-sticky-btn, #sticky-add-to-cart-bar [data-sticky-add-to-cart]');
      if (!hit) return;
      /* Is a choice missing? The page's record (window.__gcChoice, sections/main-product.liquid), asked at the
         moment of the press, when the page has one; the buttons' classes otherwise, as before. While something is
         missing the press is not held: the phone bar then glides to the selectors and the form's button asks,
         and each reports the refusal (pdp_atc_blocked). */
      var miss = choiceMissing();
      if (miss === null) {
        if (hit.classList.contains('needs-selection')) return; /* the phone button then glides to the selectors */
        if (atc.classList.contains('gc-needs-selection')) return;
      } else if (miss) return;
      if (atc.disabled || atc.hasAttribute('data-preorder')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (hit !== atc) gcT({ name: 'sticky_click', mode: 'add' });
      gcSrc = hit === atc ? 'form' : 'sticky';
      show('cart', e.isTrusted ? hit : document.activeElement);
      gcSrc = '';
    }, true);
  }

  /* ---- quick checkout: a shield over Shopify's accelerated-checkout block */
  function shield() {
    var ph = document.getElementById('payment-button-placeholder');
    if (!ph || ph.querySelector('.gcx-check-shield')) return !!ph;
    var spb = ph.querySelector('.shopify-payment-button');
    if (!spb) return false;
    if (getComputedStyle(ph).position === 'static') ph.style.position = 'relative';
    spb.setAttribute('inert', '');
    var s = el('button', 'gcx-check-shield');
    s.type = 'button';
    s.setAttribute('aria-label', T.checkout || 'Checkout');
    s.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var atc = atcBtn();
      var miss = choiceMissing();
      if (atc && (miss === null ? atc.classList.contains('gc-needs-selection') : miss)) {
        if (window.__gcAtcBlocked) window.__gcAtcBlocked('express');
        if (window.__gcPointAtVariants) window.__gcPointAtVariants();
        return;
      }
      show('checkout', s);
    });
    ph.appendChild(s);
    return true;
  }

  function boot() {
    var j = document.getElementById('gcx-check-i18n');
    try { var o = JSON.parse(j.textContent); for (var k in o) T[k] = dec(o[k]); } catch (e) {}
    guardAtc();
    if (!shield() && window.MutationObserver) {
      var ph = document.getElementById('payment-button-placeholder');
      if (ph) {
        var mo = new MutationObserver(function () { if (shield()) mo.disconnect(); });
        mo.observe(ph, { childList: true, subtree: true });
      }
    }
  }
  /* after DOMContentLoaded's own handlers: the page's guards on the button are attached there */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
})();
